import React, { useEffect, useRef } from "react";
import DeleteIcon from "./Icons/DeleteIcon";
import HoverToolTip from "./HoverToolTip";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import  Quill  from "quill";



export function InlineTextEditor({node,dom}:{node:LayoutNode|null|undefined,dom:HTMLElement|null|undefined}){

    const urlValidation = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
    
    const prevNode = useRef<LayoutNode|null|undefined>(node);

    const editor = new Quill(dom as HTMLElement,   {modules: {
       
   
        clipboard: {
           
            substituteBlockElements: true,
            magicPasteLinks: true,
            matchVisual: false,
            // Add clipboard configuration options here
          },
               /* The following allows for using backspace when editing text. See https://github.com/quilljs/quill/issues/2167 */
        keyboard: { bindings: { list: { key: 'backspace', context: { format: ['list'] }, handler: function (range:any, context:any) { if (range.length === 0 && range.index !== 0) { editor.deleteText(range.index - 1, 1); } else { editor.deleteText(range.index,range.length); } } } } }
      }});
    

      const linkFieldReference = React.useRef<HTMLInputElement>(null);

    useEffect(()=>{
        editor.focus();
        editor.setSelection(0,10000);
 
  


        if(node!=prevNode.current){

            if(prevNode.current){
                prevNode.current.forceUpdate&&prevNode.current.forceUpdate();//rerender without quill editor
            }

            prevNode.current = node;
         
        }


    
    })

    const execQuillCommand = (command:string) => {

        const selection = editor.getSelection();
        if(selection){

          const format = editor.getFormat(selection.index, selection.length);
          if(format[command])
          editor.formatText(selection.index,selection.length,command,false);
          else
          editor.formatText(selection.index,selection.length,command,true);
        }

        if(node){
            node.content = editor.root.innerHTML;
        }
    }



    const slectRef = React.useRef<any>(null);
        function bold(){
            execQuillCommand('bold');

        }

        function italic(){
            execQuillCommand('italic');

        }

        function underline(){
            execQuillCommand('underline');
  
        }

        function strikethrough(){
            execQuillCommand('strike');

        }

        function createUnOrderedList(){
            const selection = editor.getSelection();
            if (selection) {
               let format = editor.getFormat(selection.index, selection.length);
          
                if(format.list == "bullet" ){
               
                    editor.format('list', false);
                }
                else
                 editor.format('list', 'unordered');
            }

            if(node){
                node.content = editor.root.innerHTML;
            }
   
        }

        function createNumberedList(){
            const selection = editor.getSelection();
            if (selection) {
               let format = editor.getFormat(selection.index, selection.length);
           
                if(format.list == "ordered" ){
               
                    editor.format('list', false);
                }
                else
                 editor.format('list', 'ordered');
            }
            if(node){
                node.content = editor.root.innerHTML;
            }
        }

        function createLink(){
   
         
            if(linkFieldReference.current&&linkFieldReference.current.style.display == "flex"){
                return;
            }

            let format:any = editor.getFormat().link??"";
         

            saveSelection();
     
            if(linkFieldReference.current){
                linkFieldReference.current.style.display = "flex";
                let input = linkFieldReference.current.querySelector("input");
                if(input)
                    input.value = format;
                linkFieldReference.current.focus();
            
            }
       
        }

        function ClearFormatting(){

            const selection = editor.getSelection();
            if(selection)
            editor.removeFormat(selection?.index,selection?.length);
        }

        function Outdent(){
            const selection = editor.getSelection();
            if (selection) {
           
                const format = editor.getFormat(selection.index, selection.length);
                const currentIndent:any = format.indent || 0;
              editor.format('indent',currentIndent-1); 
            }
        }
        function Indent(){

            const selection = editor.getSelection();
            if (selection) {
           
                const format = editor.getFormat(selection.index, selection.length);
                const currentIndent:any = format.indent || 0;
              editor.format('indent',currentIndent+1); 
            }
 
        
        }


        const ref = React.useRef<HTMLDivElement>(null);

       function saveSelection(){

        const selection = editor.getSelection();
        if(selection){

            slectRef.current = selection;
        }
       }

       function loadSelection(){
    
        editor.focus();
        editor.setSelection(slectRef.current.index,slectRef.current.length);
       }

        const clickOutside = (e:MouseEvent)=>{
         
            let bounds = linkFieldReference.current?.getBoundingClientRect();
            const inside = bounds && e.clientX >= bounds.left && e.clientX <= bounds.right && e.clientY >= bounds.top-200 && e.clientY <= bounds.bottom;

            if(linkFieldReference.current&&linkFieldReference.current.style.display == "flex"&&!inside){

                linkFieldReference.current.style.display = "none";

            }

        }



        const enterLink = (e:any,checkButton:boolean = false)=>{
         
            if((e.key == "Enter"||checkButton) && linkFieldReference.current&&linkFieldReference.current.style.display == "flex"){
               
                e.preventDefault();
                e.stopPropagation();
                
                let url =  checkButton? (document.getElementById("url-input-field") as any).value:(e.target as HTMLInputElement).value;

                if(!urlValidation.test(url)){
                    return;
                   
                }

                if(linkFieldReference.current){
                    linkFieldReference.current.style.display = "none";
                }
              
               
    ;
                editor.focus();
                loadSelection();
                editor.formatText(slectRef.current.index,slectRef.current.length,'link',url);

                if(node)
                    node.content = editor.root.innerHTML;
         
                
           
            }   
        }

        useEffect(()=>{

            document.addEventListener("click",clickOutside);
       
            return ()=>{
                document.removeEventListener("click",clickOutside);
        
            }

        })


        const validateInput = (e:any)=>{
            let url = e.target.value;
            let dom = document.getElementById("url-input-field-validation") as any;

            if(url.startsWith("www.")){
                url = "https://"+url;
                e.target.value = url;
            }

            if(!dom)
                return;
            if(!urlValidation.test(url)&&url!=""){
                dom.style.display = "block";
            }
            else{
                e.target.style.borderColor = "black";
                dom.style.display = "none";
            }
        }

        return (

            <div 
            ref = {ref}
             className=" inline-editor-bar block-edit align-center">
                <button 
                
                onClick={(e)=>{
                    const target = e.target as HTMLElement;
                  
                    if(target){

                        let input = target.querySelector("input");
                        if(input){
                            input.click();
                            let val = input.value;
                            editor.format('color',val);
                            
                        }
                    
                    }

                }}
                >


                <div className="block-edit"
                 style={{width:"16px",height:"16px",borderRadius:"50px",overflow:"hidden",margin:"12px",flexShrink:0}}
                >
                <input type="color" 
                defaultValue={"#666666"}
                    style={{width:"32px",height:"32px",margin:"-8px",cursor:"pointer"}}
                    
                    onChange={(e)=>{
                        editor.format('color',(e.target as HTMLInputElement).value);

                }}></input>
           
                </div>
 

                <HoverToolTip text="Font Color"/>
                </button>
                <button onClick={bold}>     <BoldIcon/>     <HoverToolTip text="Bold"/>     </button>
                <button onClick={italic}>   <ItalicIcon/>    <HoverToolTip text="Italic"/>               </button>
                <button onClick={strikethrough}><StrikeThroughIcon/> <HoverToolTip text="Strike Through"/></button>
                <button onClick={underline}><UnderlineIcon/> <HoverToolTip text="Underline"/></button>
                <button onClick={createLink}><LinkIcon/> <HoverToolTip text="Link"/></button>
               
                <button onClick={createNumberedList}><OLIcon/> <HoverToolTip text="Ordered List"/></button>
                <button onClick={createUnOrderedList}><ULIcon/>  <HoverToolTip text="Unordered List"/></button>
                <button onClick={Outdent}><OutdentIcon/> <HoverToolTip text="Outdent"/></button>
                <button onClick={Indent}><IndentIcon/><HoverToolTip text="Indent"/></button>
                <button onClick={ClearFormatting}><DeleteIcon/>
                <HoverToolTip text="Clear Formatting"/>
                </button>

          
                <div id="link-enter"  ref={linkFieldReference} style={{display:"none"}} className="inline-link-bar block-edit wb-input-group"> 
                <input type="text" id="url-input-field" placeholder="URL Link" onInput={validateInput}  onKeyDown={enterLink} />
                <div id="url-input-field-validation" style={{display:"none",position:"absolute",right:"85px",bottom:"27px",color:"red",fontSize:"12px"}}>Invalid URL</div>
                <button style={{color:"#333"}} onClick={(e)=>enterLink(e,true)}>Apply</button>
                </div>
                
             

            </div>

        )

}

export function BoldIcon(){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor">
            <path d="M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"/></svg>
    )
}

export function ItalicIcon(){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor"><path d="M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"/></svg>
    )
}

export function StrikeThroughIcon(){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><path d="M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"/></svg>
    )
}

export function LinkIcon(){

    return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="currentColor"><path d="M144.6 64C64.7 64 0 128.7 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9 .3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-44.5 36.1-80.6 80.6-80.6H303.4c44.5 0 80.6 36.1 80.6 80.6c0 39.4-28.5 73-67.4 79.5l-1.9 .3c-17.4 2.9-29.2 19.4-26.3 36.8s19.4 29.2 36.8 26.3l1.9-.3c69.7-11.6 120.8-72 120.8-142.6C448 128.7 383.3 64 303.4 64H144.6zM495.4 448C575.3 448 640 383.3 640 303.4c0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9 .3c38.9 6.5 67.4 40.1 67.4 79.5c0 44.5-36.1 80.6-80.6 80.6H336.6c-44.5 0-80.6-36.1-80.6-80.6c0-39.4 28.5-73 67.4-79.5l1.9-.3c17.4-2.9 29.2-19.4 26.3-36.8s-19.4-29.2-36.8-26.3l-1.9 .3C243.1 172.4 192 232.7 192 303.4C192 383.3 256.7 448 336.6 448H495.4z"/></svg>
    )

}

export function ULIcon(){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"/></svg>
    )
}

export function OLIcon(){
    return (

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><path d="M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"/></svg>
    )

}

export function OutdentIcon(){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor"><path d="M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"/></svg>
    )
}

export function UnderlineIcon(){

    return <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 448 512" fill="currentColor"><path d="M16 56c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H112V224c0 61.9 50.1 112 112 112s112-50.1 112-112V80H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V80H40C26.7 80 16 69.3 16 56zM0 456c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"/></svg>
}

export function IndentIcon(){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor">
            
            <path d="M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"/></svg>

    )
}